import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonial_main_wrap">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4">
            <div className="testimonial_left_wrap">
              <h6>Testimonial's</h6>
              <ul>
                <li className="green">trust</li>
                <li className="orange">transparency</li>
                <li className="light-blue">perseverance</li>
              </ul>
              <h2>
                How We Are <span>Trusted</span>, See What They Say about Us
              </h2>
            </div>
          </div>
          <div className="col-md-8">
            <div className="quote_icon">
              <img src="/images/quote_icon.svg" alt="Quote Icon" />
            </div>
            <Slider {...settings}>
              <div className="testimonial_right_wrap">
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. It has survived
                  not only five centuries, but also the leap into electronic
                  typesetting, remaining essentially unchanged.
                </p>
                <div className="user_name d-flex align-items-center">
                  <div className="column">
                    <img src="/images/counter-third.jpg" alt="User" />
                  </div>
                  <div className="name_wrapper">
                    <h6>Akash Padhiyar</h6>
                    <span>Software Designer</span>
                  </div>
                </div>
              </div>
              <div className="testimonial_right_wrap">
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. It has survived
                  not only five centuries, but also the leap into electronic
                  typesetting, remaining essentially unchanged.
                </p>
                <div className="user_name d-flex align-items-center">
                  <div className="column">
                    <img src="/images/counter-third.jpg" alt="User" />
                  </div>
                  <div className="name_wrapper">
                    <h6>Akash Padhiyar</h6>
                    <span>Software Designer</span>
                  </div>
                </div>
              </div>
              <div className="testimonial_right_wrap">
                <p>
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. It has survived
                  not only five centuries, but also the leap into electronic
                  typesetting, remaining essentially unchanged.
                </p>
                <div className="user_name d-flex align-items-center">
                  <div className="column">
                    <img src="/images/counter-third.jpg" alt="User" />
                  </div>
                  <div className="name_wrapper">
                    <h6>Akash Padhiyar</h6>
                    <span>Software Designer</span>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
